import Swiper, { Navigation, Pagination } from 'swiper'

import './content-slider.scss'

const selectors = {
  container: '[data-cs]',

  swiper: '[data-cs-swiper]',
  swiperSlide: '[data-cs-swiper-slide]',
}

const initContentSlider = (container) => {
  const slides = container.querySelectorAll(selectors.swiperSlide)

  new Swiper(container.querySelector(selectors.swiper), {
    modules: [Navigation, Pagination],

    slidesPerView: 1,
    spaceBetween: 8,

    navigation: {
      prevEl: container.querySelector('.prev'),
      nextEl: container.querySelector('.next'),
    },

    pagination: {
      el: container.querySelector('.swiper-pagination'),
    },

    breakpoints: {
      1024: {
        slidesPerView: slides?.length >= 4 ? 4 : slides?.length,
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll(selectors.container)

    containers?.forEach(initContentSlider)
  },
  { once: true }
)
